import {
  Form,
  Card,
  Divider,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  DatePicker,
  Button,
  Modal,
  notification,
  message,
} from "antd";
import { useState, useEffect } from "react";
import moment from "moment";
import "./sellThirt.css";
import { format } from "../App";
import MenuBar from "./menu/MenuBar";
import { useSelector, useDispatch } from "react-redux";
import { delUser, setUser } from "../app/features/user/userSlice";
import { getNamalData, postData, getOptionDriver } from "../data/allfunction";
import { useHistory } from "react-router-dom";
import MakeDocLong from "./pdf/MakeDocLong";
import { Spinshow } from "./SellPac";
const dateFormat = "DD-MM-YYYY HH:mm:ss";
const ip = process.env.REACT_APP_IP;
const { Option } = Select;
function SellThirt() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const { token, retoken, user, user_id } = useSelector((state) => {
    return state.user;
  });
  const [listData, setlistData] = useState([]);

  const [swthird, setswthird] = useState(true);
  const [modalsave, setmodalsave] = useState(false);

  // --------------------
  const [o_name, seto_name] = useState("");
  const [o_tel, seto_tel] = useState("");
  const [o_type, seto_type] = useState("");
  const [o_make, seto_make] = useState("");
  const [o_plate, seto_plate] = useState("");
  const [o_color, seto_color] = useState("");
  const [o_power, seto_power] = useState("");
  const [o_engine, seto_engine] = useState("");
  const [o_chassis, seto_chassis] = useState("");
  const [o_weight, seto_weight] = useState(0);
  const [o_seats, seto_seats] = useState(0);

  const [a_used, seta_used] = useState("private");
  const [a_type, seta_type] = useState("new");
  const [c_insured, setc_insured] = useState(0);
  const [c_rate, setc_rate] = useState(1);
  const [c_curren, setc_curren] = useState("LAK");
  const [c_tex, setc_tex] = useState(true);

  const [a_option, seta_option] = useState({});

  const [a_premuim, seta_premuim] = useState(0);
  const [a_premuim_myself, seta_premuim_myself] = useState(0);
  const [a_discount, seta_discount] = useState(0);
  const [a_net_premuim, seta_net_premuim] = useState(0);

  const [h, seth] = useState(0);
  const [i, seti] = useState(0);

  const [c_premuim, setc_premuim] = useState(0);
  const [c_discount, setc_discount] = useState(0);
  const [c_net_premuim, setc_net_premuim] = useState(0);

  const [premuim, setpremuim] = useState(0);
  const [vat, setvat] = useState(10);
  const [register, setregister] = useState(0);
  const [total_premuim, settotal_premuim] = useState(0);

  const [startCover, setstartCover] = useState();
  const [endCover, setendCover] = useState();
  const [sent_startCover, setsent_startCover] = useState();
  const [sent_endCover, setsent_endCover] = useState();

  const [cover, setcover] = useState("");

  const [emp_paid, setemp_paid] = useState(0);

  const [modalShowPolicy, setmodalShowPolicy] = useState(false);
  const [thirdcover_option, setthirdcover_option] = useState([]);
  const [drivercover_option, setdrivercover_option] = useState([]);
  const [no, setno] = useState(0);
  const [datasentPDF, setdatasentPDF] = useState(0);

  const [provice, setprovice] = useState([]);
  const [dist, setdist] = useState([]);
  const [proviceSelect, setproviceSelect] = useState("");
  const [proviceid, setproviceid] = useState(null);
  const [distSelect, setdistSelect] = useState("");
  const [villageSelect, setvillageSelect] = useState("");

  const [loadingPDF, setloadingPDF] = useState(false);

  const [addEnd, setAddEnd] = useState(false);

  const [optionThirt, set_optionThirt] = useState([]);
  const [drivers, set_drivers] = useState([]);
  const [option_name, set_option_name] = useState("");
  const [maxdis, set_maxdis] = useState(0);

  const [typedriver, set_typedriver] = useState(null);

  const thirtClick = (e) => {
    seta_used(e.target.value);
  };

  const motorClick = (e) => {
    seta_type(e.target.value);
  };

  const currencyClick = (e) => {
    setc_curren(e.target.value);
  };
  const taxClick = (e) => {
    setc_tex(e.target.value);
  };

  const optionClick = (e) => {
    // console.log(e.target.value)
    seta_discount(0);
    const optionDetial = e.target.value;
    set_option_name(optionDetial.option_name);
    seta_premuim(optionDetial.premuim);
    seta_option(e.target.value);

    if (user_id == 44 || user_id == 6 || user_id == 103) {
      //ຖ້າວ່າຜູ້ທີ່ລອກອິນເຂົ້າມາແມ່ນ ZST1000 ຫຼື id ເທົ່າ 44 ຄ່າຄອມຫຼຸດໃດ້ສູງສຸດ100
      //ຖ້າວ່າຜູ້ທີ່ລອກອິນເຂົ້າມາແມ່ນ vt002 ຫຼື id ເທົ່າ 6 ຄ່າຄອມຫຼຸດໃດ້ສູງສຸດ100
      //ຖ້າວ່າຜູ້ທີ່ລອກອິນເຂົ້າມາແມ່ນ ZAV2403 ຫຼື id ເທົ່າ 103 ຄ່າຄອມຫຼຸດໃດ້ສູງສຸດ100
      set_maxdis(100);
    } else {
      // //ຄ່າຄອມຫຼຸດໃດ້ຕາມ ຕາບລິບ
      set_maxdis(optionDetial.maxdis);
    }
  };

  function onChange_Car(value) {
    // console.log('onChange_Car')
    let data = JSON.parse(value);
    console.log(data);
    set_option_name("");
    seta_premuim(0);
    seta_option({});

    seto_type(data.car_type_name);
    set_optionThirt(data.options);
    // console.log(data.car_type_wheel.driver_id)
    set_typedriver(data.car_type_wheel.driver_id);

    drivers.forEach((e) => {
      if (e.driver_wheel === data.car_type_wheel.driver_wheel) {
        // console.log(e.Option5)
        seti(e.Option5);
      }
    });
  }

  function onchange_Switch(value) {
    setswthird(value);
  }

  function onChange_timestart(value, dateString) {
    setstartCover(moment(value).format(dateFormat));
    setsent_startCover(value);

    // console.log('next 1 year: ',moment(value).add(1, 'Y').subtract(1, 'd').format(dateFormat))
    // console.log('now: ',moment(value).format(dateFormat))

    setendCover(moment(value).add(1, "Y").subtract(1, "d").format(dateFormat));
    setsent_endCover(moment(value).add(1, "Y").subtract(1, "d"));
  }

  function onChange_timeend(value, dateString) {
    setendCover(moment(value).format(dateFormat));
    setsent_endCover(value);
  }

  function createPolicy() {
    setmodalsave(false);
    let link = `${ip}sell_online/long`;
    const dataSetForGet = {
      o_name: o_name,
      // o_address: o_address,
      o_address: `${villageSelect} ເມືອງ ${distSelect} ແຂວງ ${proviceSelect}`,
      o_tel: o_tel,
      o_type: o_type,
      o_make: o_make,
      o_plate: o_plate,
      o_color: o_color,
      o_power: o_power,
      o_engine: o_engine,
      o_chassis: o_chassis,
      o_weight: o_weight,
      o_seats: o_seats,
      a_used: a_used,
      a_type: a_type,
      c_insured: c_insured,
      c_curren: c_curren,
      c_tex: c_tex,
      a_premuim: a_premuim,
      a_discount: a_discount,
      a_net_premuim: a_net_premuim,
      h: h,
      i: i,
      c_premuim: c_premuim,
      c_discount: c_discount,
      c_net_premuim: c_net_premuim,
      premuim: premuim,
      vat: vat,
      register: register,
      total_premuim: total_premuim,
      start: sent_startCover,
      end: sent_endCover,
      cover: cover,
      user_add: user_id,
      dateadd: Date.now(),
      emp_paid: emp_paid,
      driver_id: typedriver,
      // driver_id: 3
    };

    function setWhenUpdate(result) {
      if (result.data.fieldCount === 0) {
        setmodalsave(false);
        notification["success"]({
          message: "ແຈ້ງເຕືອນ",
          description: "ບັນທຶກຂໍ້ມູນສຳເຫຼັດ",
        });
        setTimeout(() => {
          // const win = window.open(`${l}/DocLong/${result.data.insertId}`, "_blank");
          // win.focus();
          getOneData(result.data.insertId);
          setAddEnd(false);

          seta_premuim(0);
          seta_discount(0);
          setc_premuim(0);
        }, 500);
      } else {
        setmodalsave(false);
        alert(JSON.stringify(result));
      }
    }

    if (sent_startCover === undefined || sent_endCover === undefined) {
      setmodalsave(false);
      notification["error"]({
        message: "ແຈ້ງເຕືອນ",
        description: "ກະລຸນາກວດສອບວັນທີການຄຸ້ມກັນ",
      });
    } else {
      form.resetFields();
      postData(
        message,
        link,
        dataSetForGet,
        token,
        retoken,
        user,
        dispatch,
        delUser,
        setUser,
        history,
        setWhenUpdate
      );
    }
  }
  //ດິງຂໍ້ມູນປະເພດ ອ້ອບຊັ່ນບຸກຄຸນທີສາມ
  const getOptionThirtpaty = () => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(ip + "sell_online/cover_third_tariff", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setthirdcover_option(result.data.data);
      })
      .catch((error) => console.log("error", error));
  };

  function getOneData(policy_no) {
    setloadingPDF(true);
    let link = `${ip}sell_online/getOne`;
    let dataSetForGet = { no: policy_no, user: user_id };
    function setWhenUpdate(result) {
      if (result.data.status === 200) {
        setno(policy_no);
        setdatasentPDF(result.data.rows[0]);
        setTimeout(() => {
          setmodalShowPolicy(true);
          // message.success(`ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
          getOptionDriver(result.data.rows[0], setdrivercover_option);
          getOptionThirtpaty();
        }, 1000);
      } else {
        setloadingPDF(false);
        message.success(`ບໍ່ພົບເລກທີສັນຍາ ${policy_no} ໃນລະບົບ`);
      }
    }
    postData(
      message,
      link,
      dataSetForGet,
      token,
      retoken,
      user,
      dispatch,
      delUser,
      setUser,
      history,
      setWhenUpdate
    );
  }

  useEffect(() => {
    async function getMotorTriff() {
      let l = ip + "sell_online/motor_tariff";
      let d = await getNamalData(l);
      if (d.data.data.length > 0) {
        setlistData(d.data.data);
      }
    }
    async function getDriverTriff() {
      let l = ip + "sell_online/driver_tarif";
      let d = await getNamalData(l);
      if (d.data.data.length > 0) {
        set_drivers(d.data.data);
      }
    }
    getDriverTriff();
    getMotorTriff();
  }, []);

  useEffect(() => {
    // --------
    if (c_curren === "LAK") {
      setc_rate(1);
    }

    // ---------------ຄິດໄລ່ຄ່າທຳນຽມຕົ້ນໂຕລົດ
    let c;
    if (c_tex) {
      c = 3.5 / 100;
    } else {
      c = 4.2 / 100;
    }
    let c_p = c_insured * c_rate * c;
    setc_premuim(c_p);

    // ------------------ ຄິດໄລ່ຄ່າທຳນຽມໂຕລົດ
    let c_n;
    if (c_discount > 0) {
      c_n = c_p * (c_discount / 100);
    } else {
      c_n = 0;
    }
    setc_net_premuim(c_p - c_n);

    // --------------- ຄິດໄລຄ່າທຳນຽມຕົນບຸກຄົນທີ່ສາມທີ່ເລືອກອັດຕະໂນມັດ
    if (swthird) {
      if (a_option.premuim != undefined) {
        seta_premuim(a_option.premuim);
      }
    } else {
      seta_premuim(a_premuim_myself);
    }

    // ----------------------ຄິດໄລ່ຄ່າທຳນຽມບຸກຄົນທີສາມ
    let a_n;
    if (a_discount > 0) {
      a_n = a_premuim * (a_discount / 100);
    } else {
      a_n = 0;
    }
    seta_net_premuim(a_premuim - a_n);

    // ---------------------ຄິດໄລ່ປົກປ້ອງສິດ
    seth(a_net_premuim * 0.05);

    // ຄິດໄລ່ຄ່າທຳນຽມບໍ່ລວມອາກອນ----------
    let pr = a_net_premuim + h + i + c_net_premuim;
    setpremuim(pr);

    // ຄິດໄລອາກອນມູູນຄ່າເພີ່ມ------------

    let v = pr * 0.07;
    setvat(v);

    // ຄິດໄລ່ຄ່າຂື້ນທະບຽນ-----------
    let r;
    if (pr <= 10000000) {
      r = 20000;
    } else if (pr <= 50000000) {
      r = 30000;
    } else if (pr <= 100000000) {
      r = 40000;
    } else {
      r = 100000;
    }
    setregister(r);

    // ຄິດໄລ່ລວມມູນຄ່າຕ້ອງຈ່າຍ----------
    settotal_premuim(pr + v + r);

    //---------------------
    let cc;
    if (c_insured > 0) {
      cc = "-C";
    } else {
      cc = "";
    }
    let cv = option_name + "-H-I5" + cc;
    setcover(cv);
  }, [
    c_curren,
    c_tex,
    c_insured,
    c_rate,
    c_discount,
    a_premuim_myself,
    a_discount,
    a_premuim,
    a_net_premuim,
    h,
    i,
    c_net_premuim,
    a_option,
    swthird,
  ]);

  useEffect(async () => {
    let l = ip + "address/pro";
    let p = await getNamalData(l);
    p.status === 200 && setprovice(p.data);
  }, []);
  useEffect(async () => {
    if (proviceid != null) {
      let l = ip + "address/dist/" + proviceid;
      let d = await getNamalData(l);
      d.status === 200 && setdist(d.data);
    }
  }, [proviceid]);

  function onChange_pro(p) {
    let pro = JSON.parse(p);
    setproviceid(pro.provice_id);
    setproviceSelect(pro.provice_name);
    setdist([]);
  }
  function onChange_dist(d) {
    let dis = JSON.parse(d);
    setdistSelect(dis.dist_name);
  }
  function onChange_v(v) {
    setvillageSelect(v.target.value);
  }
  const submitForm = (e) => {
    function add() {
      if (option_name == "") {
        alert("ກະລຸນາເລືອກ  Option ໃຫ້ຖືກຕ້ອງ");
      } else {
        setmodalsave(true);
      }
    }

    if (c_premuim > 0) {
      alert("ທ່ານກຳລັງຈະອອກສັນຍາປະກັນໄພໂຕລົດ");
      if (option_name == "A3") {
        add();
      } else {
        if (user_id == 6 || user_id == 103) {
          //ຖ້າວ່າຜູ້ທີ່ລອກອິນເຂົ້າມາແມ່ນ vt002 ຫຼື id ເທົ່າ 6 ສາມາດຂາຍປະກັນໄພຮອບດ້ານ A2 ໄດ້
          //ຖ້າວ່າຜູ້ທີ່ລອກອິນເຂົ້າມາແມ່ນ ZAV2403 ຫຼື id ເທົ່າ 103 ສາມາດຂາຍປະກັນໄພຮອບດ້ານ A2 ໄດ້
          alert("ທ່ານກຳລັງຂາຍປະກັນໄພລົດແບບຮອບດ້ານໂດຍທີ່ໃຊ້ທາງເລືອກບໍ່ແມ່ນ A3 ");
          add();
        } else {
          alert("ປະກັນໂຕລົດແມ່ນຂາຍສະເພາະ ທາງເລືອກ A3 ເທົ່ານັ້ນ");
        }
      }
    } else {
      add();
    }

    // form.resetFields()
  };
  return (
    <>
      <MenuBar />
      {loadingPDF ? (
        <Spinshow />
      ) : (
        <Form
          form={form}
          name="sellpac"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={submitForm}
          autoComplete="off"
        >
          <div className="container">
            <Card className="C">
              <Divider orientation="left" plain>
                ຂໍ້ມູນຂອງຜູ້ໄດ້ຮັບການປະກັນໄພ
              </Divider>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 10 }}>
                  <Input
                    className="TI"
                    placeholder="ຊື່ ແລະ ນາມສະກຸນ"
                    onChange={(e) => {
                      seto_name(e.target.value);
                    }}
                  />
                  {/* <Input className='TI' placeholder="ທີ່ຢູ່"
                                onChange={(e) => {
                                    seto_address(e.target.value)
                                }}
                            /> */}
                  <div className="row">
                    <div className="col">
                      <Select
                        placeholder="ເລືອກແຂວງ"
                        optionFilterProp="children"
                        onChange={onChange_pro}
                        className="TI"
                        style={{ width: "100%" }}
                      >
                        {provice.map((v) => {
                          return (
                            <Option
                              key={v.provice_id}
                              value={JSON.stringify(v)}
                            >
                              {v.provice_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                    <div className="col">
                      <Select
                        placeholder="ເລືອກເມືອງ"
                        optionFilterProp="children"
                        onChange={onChange_dist}
                        className="TI"
                        style={{ width: "100%" }}
                      >
                        {dist.map((v) => {
                          return (
                            <Option key={v.dist_id} value={JSON.stringify(v)}>
                              {v.dist_name}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                    <div className="col">
                      <Input
                        className="TI"
                        placeholder="ພິມຊື່ບ້ານ"
                        onChange={onChange_v}
                      />
                    </div>
                  </div>
                  <Input
                    className="TI"
                    placeholder="ໂທລະສັບ"
                    onChange={(e) => {
                      seto_tel(e.target.value);
                    }}
                  />
                  <Form.Item
                    // label=" ເລືອກປະເພດລົດ::"
                    name="o_type"
                    rules={[
                      {
                        required: true,
                        message: "ກະລຸນາເລືອກ  ເລືອກປະເພດລົດ ເສຍກ່ອນ",
                      },
                    ]}
                    className="mb-0"
                  >
                    <Select
                      placeholder="ປະເພດລົດ"
                      optionFilterProp="children"
                      onChange={onChange_Car}
                      className="TI"
                      style={{ width: "100%" }}
                    >
                      {listData.map((v) => {
                        return (
                          <Option key={v.car_type_id} value={JSON.stringify(v)}>
                            {v.car_type_name_la}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Input
                    className="TI"
                    placeholder="ຫຍີ່ຫໍ້"
                    onChange={(e) => {
                      seto_make(e.target.value);
                    }}
                  />
                  <Input
                    className="TI"
                    placeholder="ເລກທະບຽນ"
                    onChange={(e) => {
                      seto_plate(e.target.value);
                    }}
                  />
                  <Input
                    className="TI"
                    placeholder="ສີລົດ"
                    onChange={(e) => {
                      seto_color(e.target.value);
                    }}
                  />
                  <Input
                    className="TI"
                    placeholder="ຄວາມແຮງເປັນ ເຊເຊ"
                    onChange={(e) => {
                      seto_power(e.target.value);
                    }}
                  />
                  <Input
                    className="TI"
                    placeholder="ເລກຈັກ"
                    onChange={(e) => {
                      seto_engine(e.target.value);
                    }}
                  />
                  <Input
                    className="TI"
                    placeholder="ເລກຖັງ"
                    onChange={(e) => {
                      seto_chassis(e.target.value);
                    }}
                  />
                  <InputNumber
                    className="TIN"
                    max={50}
                    placeholder="ນ້ຳໜັກຄິດໄລ່ເປັນໂຕນ"
                    onChange={(e) => {
                      seto_weight(e);
                    }}
                  />
                  <InputNumber
                    className="TIN"
                    min={0}
                    max={50}
                    placeholder="ຈຳນວນບ່ອນນັ່ງ"
                    onChange={(e) => {
                      seto_seats(e);
                    }}
                  />
                </div>
              </div>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                ປະເພດຂອງສັນຍາປະກັນໄພ
              </Divider>
              ພາກທີ 1: ການປະກັນໄພ ທາງແພ່ງຕໍ່ບຸກຄົນທີສາມ
              <Radio.Group onChange={thirtClick} value={a_used} className="R">
                <Radio value={"private"}>ລົດສ່ວນຕົວ</Radio>
                <Radio value={"business"}>ຮັບຈ້າງ</Radio>
              </Radio.Group>
              <Radio.Group onChange={motorClick} value={a_type} className="R">
                <Radio value={"new"}>ສັນຍາໃໝ່</Radio>
                <Radio value={"renew"}>ຕໍ່ສັນຍາ</Radio>
              </Radio.Group>
              <br />
              ພາກທີ 2: ການປະກັນໄພ ຕົວລົດ (ມູນຄ່າລົດໃໝ່ສຳຫຼັບຄ້ຳປະກັນຂໍ້ ຄ ຫຼື ງ)
              <br />
              <Radio.Group
                onChange={currencyClick}
                value={c_curren}
                className="R"
              >
                <Radio value={"LAK"}>LAK</Radio>

                {/* 
                <Radio value={"USD"}>USD</Radio>
                <Radio value={"THB"}>THB</Radio>
                */}
              </Radio.Group>
              <div style={{ display: "flex" }}>
                <div style={{ flex: 2, paddingRight: 5 }}>
                  <InputNumber
                    className="TIN"
                    placeholder="ມູນຄ່າລົດ"
                    onChange={(e) => setc_insured(e)}
                  />
                </div>
                {c_curren !== "LAK" && (
                  <div style={{ flex: 1 }}>
                    <InputNumber
                      min={1}
                      className="TIN"
                      placeholder="ອັດຕາແລກປ່ຽນ"
                      onChange={(e) => setc_rate(e)}
                    />
                  </div>
                )}
              </div>
              <Radio.Group onChange={taxClick} value={c_tex} className="R">
                <Radio value={true}>ເສຍພາສີ</Radio>
                <Radio value={false}>ບໍ່ເສຍພາສີ</Radio>
              </Radio.Group>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                ທາງເລືອກສຳຫຼັບປະກັນໄພລົດ
              </Divider>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>ຂອບເຂດການຄຸ້ມກັນ ແລະ ທາງເລືອກ</th>
                    <th>ຄິດໄລຄ່າທຳນຽມເບື້ອງຕົ້ນ</th>
                    <th>ສ່ວນຫຼຸດ</th>
                    <th>ຄ່າທຳນຽມຕົວຈິງ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      ຄວາມຮັບຜິດຊອບທາງແຜ່ງຕໍ່ບຸກຄົນທີສາມ
                      <Form.Item
                        // label=" ເລືອກປະເພດລົດ::"
                        name="o_optinname"
                        rules={[
                          {
                            required: true,
                            message: "ກະລຸນາເລືອກ  Option",
                          },
                        ]}
                        className="mb-0"
                      >
                        <Radio.Group
                          onChange={optionClick}
                          value={a_option}
                          className="R"
                        >
                          {optionThirt.map((e, k) => {
                            return (
                              <Radio key={k} value={e}>
                                {e.option_name}
                              </Radio>
                            );
                          })}
                        </Radio.Group>
                      </Form.Item>
                      <hr />
                      ໃສ່ລາຄາອັດຕະໂນມັດ
                      <Switch
                        className="SW"
                        onChange={onchange_Switch}
                        checkedChildren="ປິດ"
                        unCheckedChildren="ເປີດ"
                        defaultChecked={swthird}
                      />
                      <br />
                      {swthird && (
                        <>
                          {/* <Select
                                                placeholder="ກະລຸນາເລືອກທາງເລືອກ"
                                                optionFilterProp="children"
                                                onChange={onChange_Car}
                                                className='SC'
                                            >
                                                {
                                                    listData.map((v) => {
                                                        return (
                                                            <Option key={v.name} value={JSON.stringify(v)}>{v.name}</Option>
                                                        )
                                                    })
                                                }
                                            </Select> */}
                        </>
                      )}
                    </td>
                    <td>
                      <Input
                        readOnly={swthird ? true : false}
                        className="TIN"
                        value={a_premuim}
                        onChange={(e) => seta_premuim_myself(e.target.value)}
                        placeholder="ຄ່າທຳນຽມຕົ້ນ"
                      />
                    </td>
                    <td>
                      <InputNumber
                        className="TIN"
                        min={0}
                        //   max={maxdis}
                        max={maxdis}
                        value={a_discount}
                        placeholder="ສ່ວນຫຼຸດ"
                        onChange={(e) => seta_discount(e)}
                      />
                    </td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        value={format(a_net_premuim)}
                        placeholder="ຄ່າທຳນຽມຕົວຈິງ"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>ປົກປ້ອງສິດແລະຮຽກສິນທົດແທນ</td>
                    <td>
                      <InputNumber
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ປົກປ້ອງສິດ"
                        value={h}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={3}>ຜູ້ຂັບຂີ່ ແລະ ຜູ້ໂດຍສານ</td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ຜູ້ຂັບຂີ່"
                        value={format(i)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>ຄວາມເສຍຫາຍຕໍ່ກັບໂຕລົດ</td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ຄ່າທຳນຽມຕົ້ນ"
                        value={format(c_premuim)}
                      />
                    </td>
                    <td>
                      <InputNumber
                        className="TIN"
                        min={0}
                        max={60}
                        placeholder="ສ່ວນຫຼຸດ %"
                        value={c_discount}
                        onChange={(e) => setc_discount(e)}
                      />
                    </td>
                    <td>
                      <Input
                        className="TIN"
                        readOnly
                        min={0}
                        placeholder="ຄ່າທຳນຽມຕົວຈິງ"
                        value={format(c_net_premuim)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                ຄິດໄລຄ່າທຳນຽມ
              </Divider>
              <div className="B">
                <div className="B1"> ຄ່າທຳນຽມຕົວຈິງບໍ່ທັນລວມອາກອນ </div>
                <div className="B2">{format(premuim)}</div>
              </div>
              <div className="B">
                <div className="B1"> ອາກອນມູນຄ່າເພີ່ມ </div>
                <div className="B2">{format(vat)}</div>
              </div>
              <div className="B">
                <div className="B1"> ຄ່າຂື້ນທະບຽນ </div>
                <div className="B2">{format(register)}</div>
              </div>
              <div className="B">
                <div className="B1"> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
                <div className="B2">{format(total_premuim)}</div>
              </div>
            </Card>
            <Card className="C">
              <Divider orientation="left" plain>
                ການຊຳລະເງິນ
              </Divider>
              <div className="BDP">
                <div className="B1DP">ສະຖານະການຊຳລະ</div>
                <div className="B2DP">
                  <Radio.Group
                    onChange={(e) => {
                      setemp_paid(e.target.value);
                    }}
                    value={emp_paid}
                  >
                    <Radio value={0}>ລໍຖ້າການຊຳລະ</Radio>
                    <Radio value={1}>ຊຳລະສົມບູນ</Radio>
                  </Radio.Group>
                </div>
              </div>
            </Card>
            <br />
            *ເພີ່ມວັນສິ້ນສຸດດ້ວຍຕົນເອງ{" "}
            <span style={{ color: "red" }}>
              {" "}
              (ຖ້າປິດສັນຍາຈະຄຸ້ມກັນເປັນເວລາ 1 ປີ){" "}
            </span>
            <Switch
              checked={addEnd}
              checkedChildren="ປິດ"
              unCheckedChildren="ເປີດ"
              onChange={(e) => {
                setAddEnd(e);
                form.setFieldsValue({ start: "" });
                form.setFieldsValue({ end: "" });
              }}
            />
            <div className="BDP mt-2">
              <div className="B1DP">
                <Form.Item
                  label="ວັນທີເລີ່ມຄຸ້ມກັນ::"
                  name="start"
                  rules={[
                    {
                      required: true,
                      message: "ກະລຸນາເລືອກ ວັນທີເລີ່ມຄຸ້ມກັນ ເສຍກ່ອນ",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="ວັນທີເລີ່ມຄຸ້ມກັນ"
                    className="DP"
                    showTime
                    onChange={onChange_timestart}
                    format={dateFormat}
                    disabledDate={(current) =>
                      current.isBefore(moment().subtract(1, "day"))
                    }
                  />
                </Form.Item>
              </div>

              {addEnd && (
                <div className="B2DP">
                  <Form.Item
                    label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                    name="end"
                    rules={[
                      {
                        required: true,
                        message: "ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="ວັນທີສຶ້ນສຸດຄຸ້ມກັນ"
                      className="DP"
                      showTime
                      onChange={onChange_timeend}
                      format={dateFormat}
                    />
                  </Form.Item>
                </div>
              )}

              {/* <div className='B2DP'>
                                    <Form.Item
                                        label=" ວັນທີສຶ້ນສຸດຄຸ້ມກັນ::"
                                        name="end"
                                        rules={[{ required: true, message: 'ກະລຸນາເລືອກ  ວັນທີສຶ້ນສຸດຄຸ້ມກັນ ເສຍກ່ອນ' }]}
                                    >
                                        <DatePicker
                                            placeholder='ວັນທີສຶ້ນສຸດຄຸ້ມກັນ'
                                            className='DP'
                                            showTime
                                            onChange={onChange_timeend}
                                            format={dateFormat}
                                        />
                                    </Form.Item>
                                </div> */}
            </div>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
              >
                ບັນທຶກຂໍ້ມູນ
              </Button>
            </Form.Item>
            {/* <Button type="primary" block className='mt-2'
                    onClick={() => {
                        getOptionDriver()
                        getOptionThirtpaty()
                        setmodalsave(true)
                    }
                    }
                >
                    ບັນທຶກຂໍ້ມູນ
                </Button> */}
          </div>
        </Form>
      )}
      <br />
      <Modal
        title="ກວດຂໍ້ມູນໃຫ້ລະອຽດກ່ອນການບັນທືກ"
        visible={modalsave}
        onOk={createPolicy}
        onCancel={() => setmodalsave(false)}
        okText="ຕົກລົງ"
        cancelText="ຍົກເລີກ"
      >
        <div className="B">
          <div className="B1"> ຜູ້ໃດ້ຮັບການປະກັນໄພ </div>
          <div className="B2">{o_name}</div>
        </div>
        <div className="B">
          <div className="B1"> ເລກທະບຽນ </div>
          <div className="B2">{o_plate}</div>
        </div>
        <div className="B">
          <div className="B1"> ເລກຈັກ </div>
          <div className="B2">{o_engine}</div>
        </div>
        <div className="B">
          <div className="B1"> ເລກຖັງ </div>
          <div className="B2">{o_chassis}</div>
        </div>
        <div className="B">
          <div className="B1"> ການຄຸ້ມກັນ </div>
          <div className="B2">{cover}</div>
        </div>
        <div className="B">
          <div className="B1"> ວັນທີເລີ່ມຄຸ້ມກັນ </div>
          <div className="B2">{startCover}</div>
        </div>
        <div className="B">
          <div className="B1"> ວັນທີສຶ້ນສຸດຄຸ້ມກັນ </div>
          <div className="B2">{endCover}</div>
        </div>
        <div className="B">
          <div className="B1"> ລວມມູນຄ່າຕ້ອງຈ່າຍ </div>
          <div className="B2">{format(total_premuim)}</div>
        </div>
        <div className="B">
          <div className="B1"> ສະຖານະການຈ່າຍເງິນ </div>
          <div className="B2">
            {" "}
            {emp_paid === 1 ? "ຊຳລະສົມບູນ" : "ລໍຖ້າການຊຳລະ"}{" "}
          </div>
        </div>
      </Modal>
      <Modal
        width={"720px"}
        title="ລາຍລະອຽດຂອງສັນຍາການຂາຍ"
        visible={modalShowPolicy}
        closable={false}
        // onOk={() => setmodalShowPolicy(false)}
        // onCancel={() => setmodalShowPolicy(false)}
        footer={[
          <Button
            key="ກັບຄືນ"
            onClick={() => {
              setloadingPDF(false);
              setmodalShowPolicy(false);
            }}
          >
            ປິດ
          </Button>,
        ]}
      >
        {modalShowPolicy === true ? (
          // <MakeDocLongFirst
          //     no={no}
          //     user={user}
          //     oneData={datasentPDF}
          //     thirdcover_option={thirdcover_option}
          //     drivercover_option={drivercover_option}
          // />
          <MakeDocLong
            no={no}
            user={user}
            oneData={datasentPDF}
            thirdcover_option={thirdcover_option}
            drivercover_option={drivercover_option}
          />
        ) : null}
      </Modal>
    </>
  );
}

export default SellThirt;
